var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMpIconCommercialLoan = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_17909_16038)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#3EE0D7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5629 14.2497C22.8044 14.2497 23.0004 14.0537 23.0004 13.8122V12.9372C23.0004 12.7753 22.9112 12.6274 22.7686 12.5513L16.2059 9.05119C16.0772 8.98294 15.9232 8.98294 15.7946 9.05119L9.23188 12.5513C9.08925 12.6274 9 12.7753 9 12.9372V13.8122C9 14.0537 9.19601 14.2497 9.43751 14.2497H10.7501V21.2499H9.58364C9.26076 21.2499 9 21.5107 9 21.8336V22.4172C9 22.7392 9.26076 23 9.58364 23H22.4177C22.7397 23 23.0004 22.7392 23.0004 22.4164V21.8327C23.0004 21.5107 22.7397 21.2499 22.4168 21.2499H21.2504V14.2497H22.5629ZM20.084 21.2499H11.9173V14.2497H20.084V21.2499Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7788 18.188H16.2224C16.4219 18.188 16.5838 18.3507 16.5838 18.5555C16.5838 18.755 16.4211 18.9169 16.2224 18.9169H14.9799C14.7384 18.9169 14.5424 19.1129 14.5424 19.3544C14.5424 19.5959 14.7384 19.7919 14.9799 19.7919H15.5627V20.2294C15.5627 20.4709 15.7587 20.6669 16.0002 20.6669C16.2417 20.6669 16.4377 20.4709 16.4377 20.2294V19.77C17.017 19.6668 17.4588 19.1627 17.4588 18.5494C17.4588 17.8677 16.9041 17.3129 16.2224 17.3129H15.7788C15.5793 17.3129 15.4174 17.1502 15.4174 16.9454C15.4174 16.7459 15.5802 16.584 15.7788 16.584H17.0213C17.2628 16.584 17.4588 16.388 17.4588 16.1465C17.4588 15.905 17.2628 15.709 17.0213 15.709H16.4377V15.2715C16.4377 15.03 16.2417 14.834 16.0002 14.834C15.7587 14.834 15.5627 15.03 15.5627 15.2715V15.7309C14.9834 15.8341 14.5415 16.3382 14.5415 16.9516C14.5415 17.6332 15.0963 18.188 15.7788 18.188Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_17909_16038",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_17909_16038"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMpIconCommercialLoan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mp_icon_Commercial_Loan.b13e3509c3890b04296118f8710cc16a.svg";